import type {
  AtualizarTabelaPrecoDto, CriarTabelaPrecoDto, ListarTabelasPrecoQuery, NovaVigenciaDto, TabelaPrecoResponse,
} from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

export function useTabelasPreco(q: Partial<ListarTabelasPrecoQuery> = {}) {
  return useConsulta<TabelaPrecoResponse[]>(['tabelas-preco'], '/tabelas-preco', { query: q });
}

export function useTabelaPreco(id: string | undefined) {
  return useConsulta<TabelaPrecoResponse>(['tabelas-preco', id], `/tabelas-preco/${id}`, { ativo: !!id });
}

export function useCriarTabelaPreco() {
  return useMutacao<TabelaPrecoResponse, CriarTabelaPrecoDto>({
    metodo: 'POST', caminho: () => '/tabelas-preco', corpo: (v) => v, invalidar: [['tabelas-preco']],
  });
}

export function useAtualizarTabelaPreco() {
  return useMutacao<TabelaPrecoResponse, { id: string } & AtualizarTabelaPrecoDto>({
    metodo: 'PATCH',
    caminho: (v) => `/tabelas-preco/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['tabelas-preco']],
  });
}

/** Nova vigencia: a API fecha a vigente e insere esta (valores nunca sao editados). */
export function useNovaVigencia() {
  return useMutacao<unknown, { tabelaId: string } & NovaVigenciaDto>({
    metodo: 'POST',
    caminho: (v) => `/tabelas-preco/${v.tabelaId}/vigencias`,
    corpo: ({ tabelaId: _t, ...resto }) => resto,
    invalidar: [['tabelas-preco']],
  });
}
